import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import {
  updatePatAlertData,
  updatePatAlertStatus,
} from '../../redux/slices/scheduler/appointmentSlice';
import { useDispatch, useSelector } from 'react-redux';

function AlertPopup({
  headerData,
  alertData = '',
  patientId,
  handleReload,
  alertNotifyCheck,
  close,
}) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const [alertType, setAlertType] = useState('1');
  const [notify, setNotify] = useState(alertNotifyCheck === '1' ? true : false);
  const [alertMsg, setAlertMsg] = useState('');

  useEffect(() => {
    if (alertData) {
      setAlertType(alertData?.alert_type);
      //setNotify(alertData?.alert_notification === '1' ? true : false);
      setAlertMsg(alertData?.alert);
    }
  }, [alertData]);

  const handleAlertNotifyCheck = async (e) => {
    e.target.checked ? setNotify(true) : setNotify(false);
    const alertNotify = e.target.checked === true ? '1' : '0';
    try {
      const response = await post(
        'api/patient/ProgressNote/updateAlertNotification',
        {
          patientId: patientId,
          alertNotify: alertNotify, //1-> if checked
          loginUserId: user?.id,
        }
      );
      if (response.status === 200) {
        setUiMessage(
          'suc',
          `Alert notification has been ${
            alertNotify === '1' ? `active` : `inactive`
          } successfully.`
        );
        dispatch(
          updatePatAlertStatus({ active_alert_notification: alertNotify })
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleUpdate = async () => {
    if (alertMsg) {
      try {
        const response = await post(
          'api/patient/ProgressNote/updateSpecificAlert',
          {
            alertId: alertData?.id,
            alertNoti: notify === true ? '1' : '0', //1-> if checked
            alertType: alertType, //0->Clinical, 1->billing
            specificAlert: alertMsg,
            appId: '',
            loginUserId: user?.id,
          }
        );
        if (response.status === 200) {
          if (response.data.response === 'success') {
            setUiMessage('suc', 'Alert has been updated successfully.');
            dispatch(updatePatAlertData(response.data?.getSpecificAlertData));
            close();
            //handleReload();
          } else {
            setUiMessage('err', 'Updating alert failed.');
          }
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    } else {
      setUiMessage('err', 'Alert message is required.');
    }
  };
  const handleSave = async () => {
    if (alertMsg) {
      try {
        const response = await post(
          'api/patient/ProgressNote/saveSpecificAlert',
          {
            patientId: patientId,
            alertNoti: notify === true ? '1' : '0', //1-> if checked
            alertType: alertType, //0->Clinical, 1->billing
            specificAlert: alertMsg,
            appId: '',
            loginUserId: user?.id,
          }
        );
        if (response.status === 200) {
          if (response.data.response === 'success') {
            setUiMessage('suc', 'Alert has been added successfully.');
            dispatch(updatePatAlertData(response.data?.getSpecificAlertData));

            close();
            //handleReload();
          } else {
            setUiMessage('err', 'Adding alert failed.');
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    } else {
      setUiMessage('err', 'Alert message is required.');
    }
  };

  return (
    <div className="modalBackground">
      <div className="insu-act-sec alert-main-con">
        <div className="main-contnr-hdr flex-sec white-bg">
          <div className="hdr-pt-info">
            <span className="black-txt clear-right10">Alert:</span>
            {headerData?.patName}
            <span className="red"> | </span>
            ID: {headerData?.chart_number}
            <span className="red"> | </span>
            {headerData?.age}-[{headerData?.gender.toUpperCase().substr(0, 1)}]
            <span className="red"> | </span>
            DOB:{headerData?.dob}
          </div>
          <div className="close" onClick={close}>
            X
          </div>
        </div>
        <div className="insu-act-sec-bdy fontsize13">
          <div className="insu-act-sec-bdy-lft flex-sec alt-rw">
            <span className="nsu-act-lbl">Type:</span>
            <span className="nsu-act-val">
              <span className="appt-check-sec" style={{ marginLeft: '0px' }}>
                <span className="book-appt-check">
                  <input
                    onChange={(e) => setAlertType('0')}
                    type="radio"
                    value="0"
                    checked={alertType === '0'}
                  />
                </span>
                <span className="book-appt-check-val">Clinical</span>
              </span>
              <span className="appt-check-sec">
                <span className="book-appt-check">
                  <input
                    onChange={(e) => setAlertType('1')}
                    type="radio"
                    value="1"
                    checked={alertType === '1'}
                  />
                </span>
                <span className="book-appt-check-val">Billing</span>
              </span>
              <span className="appt-check-sec" style={{ marginLeft: '60px' }}>
                <span className="book-appt-check">
                  <input
                    type="checkbox"
                    className=""
                    checked={notify}
                    // onChange={(e) =>
                    //   e.target.checked ? setNotify(true) : setNotify(false)
                    // }
                    onChange={(e) => handleAlertNotifyCheck(e)}
                  />
                </span>
                <span className="book-appt-check-val">Notification active</span>
              </span>
            </span>
          </div>
          <div className="insu-act-sec-bdy-lft flex-sec">
            <span className="nsu-act-lbl">
              Alert:<span className="required-fld">*</span>
            </span>
            <span className="nsu-act-val">
              <textarea
                className="alert-txt-area"
                placeholder=""
                onChange={(e) => setAlertMsg(e.target.value)}
                value={alertMsg}
              ></textarea>
            </span>
          </div>
        </div>
        <div
          className="insu-act-sec-bdy-rw white-bg"
          style={{
            padding: '9px 0px 0px',
            display: 'inline-block',
            marginBottom: '0px',
          }}
        >
          {alertData ? (
            <button
              className="actn-yes"
              style={{ width: '20%' }}
              onClick={handleUpdate}
            >
              Update
            </button>
          ) : (
            <button
              className="actn-yes"
              style={{ width: '20%' }}
              onClick={handleSave}
            >
              Save
            </button>
          )}
          <button className="actn-No" style={{ width: '20%' }} onClick={close}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default AlertPopup;
